import type { DashboardOrder } from '../model'

/**
 * Groups DashboardOrder objects by their data.status property.
 * @param orders - Array of DashboardOrder
 * @returns Record mapping status to arrays of DashboardOrder
 */
export function transformAndGroupDashboardOrdersByStatus(
  orders: DashboardOrder[],
): Record<string, DashboardOrder[]> {
  return orders.reduce((acc, order) => {
    if (!acc[order.data.status])
      acc[order.data.status] = []
    acc[order.data.status].push(order)
    return acc
  }, {} as Record<string, DashboardOrder[]>)
}
